import { Identifier } from 'src/types/utilityTypes';
import api from 'src/utils/ajax';
import { camelcaseKeys } from 'src/utils/camelize-keys';

import { DnsBlockActivity } from '../platform/_types';

export const DNS_MIGRATION_GUIDE_URL =
  'https://www.exercise.com/support/add-cnames/';

export const DNS_BLOCK_PATH = '/dns-block';

export interface DnsBlockActionResponse {
  dnsBlockActivity?: DnsBlockActivity;
  migrationComplete?: boolean;
  success?: boolean;
}

export const dnsBlockSnooze = async (): Promise<DnsBlockActionResponse> => {
  const response = await api.post('/api/v5/platforms/dns_block_snooze');
  return camelcaseKeys(response.data, { deep: true }) as DnsBlockActionResponse;
};

export const dnsBlockVerify = async (): Promise<DnsBlockActionResponse> => {
  const response = await api.post('/api/v5/platforms/dns_block_verify');
  return camelcaseKeys(response.data, { deep: true }) as DnsBlockActionResponse;
};

export const dnsBlockAdminSnooze = async (
  platformId: Identifier,
  minutes: number
): Promise<DnsBlockActionResponse> => {
  const response = await api.post(
    `/api/v5/platforms/${platformId}/dns_block_admin_snooze`,
    { minutes }
  );
  return camelcaseKeys(response.data, { deep: true }) as DnsBlockActionResponse;
};
